// src/pages/ManageMedicines.jsx - COMPLETE WITH SANITIZATION
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Redux Actions
import {
  listMedicines,
  fetchTopSelling,
} from "../../Redux/actions/adminActions/medicineActions";

// Components
import MedicineStatsCards from "../../components/adminComponents/Medicines/MedicineStatsCards";
import MedicineListTable from "../../components/adminComponents/Medicines/MedicineListTable";
import AddMedicineModal from "../../components/adminComponents/Medicines/AddMedicineModal";
import EditMedicineModal from "../../components/adminComponents/Medicines/EditMedicineModal";
import AddStockModal from "../../components/adminComponents/Medicines/AddStockModal";
// import SellMedicineModal from "../../components/adminComponents/Medicines/SellMedicineModal"; // ✅ REMOVE
import TopSellingChart from "../../components/adminComponents/Medicines/TopSellingChart";
import LowStockChart from "../../components/adminComponents/Medicines/LowStockChart";

import { Plus, TrendingUp, AlertTriangle, Pill, X } from "lucide-react";
import { motion } from "framer-motion";

const ManageMedicines = () => {
  const dispatch = useDispatch();

  const { medicines, loading, error, report, topSelling } = useSelector(
    (state) => state.adminMedicines
  );

  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = () => setRefreshKey((prev) => prev + 1);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStockModal, setShowStockModal] = useState(false);
  // const [showSellModal, setShowSellModal] = useState(false); // ✅ REMOVE

  const [showTopSellingModal, setShowTopSellingModal] = useState(false);
  const [showLowStockModal, setShowLowStockModal] = useState(false);

  const [selectedMedicine, setSelectedMedicine] = useState(null);

  useEffect(() => {
    dispatch(listMedicines());
    dispatch(fetchTopSelling());
  }, [dispatch, refreshKey]);

  const handleOpenEdit = (med) => {
    setSelectedMedicine(med);
    setShowEditModal(true);
  };

  const handleOpenStock = (med) => {
    setSelectedMedicine(med);
    setShowStockModal(true);
  };

  // ✅ REMOVE this function
  // const handleOpenSell = (med) => {
  //   setSelectedMedicine(med);
  //   setShowSellModal(true);
  // };

  return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh", padding: "2rem" }}>
      <div className="container-fluid">
        {/* Header Section */}
        <div className="row mb-4">
          <div className="col-12">
            <div
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                padding: "2rem",
                borderRadius: "16px",
                color: "white",
                boxShadow: "0 8px 24px rgba(102, 126, 234, 0.25)",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                  <h2 className="mb-2 fw-bold d-flex align-items-center">
                    <Pill size={32} className="me-3" />
                    Medicine Management
                  </h2>
                 
                </div>
                <div className="d-flex gap-3 flex-wrap">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.97 }}
                    className="btn btn-light btn-lg d-flex align-items-center"
                    style={{
                      borderRadius: "12px",
                      padding: "0.75rem 2rem",
                      fontWeight: "600",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    }}
                    onClick={() => setShowAddModal(true)}
                  >
                    <Plus size={20} className="me-2" />
                    Add Medicine
                  </motion.button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Action Cards */}
        <div className="row mb-4">
          <div className="col-md-6">
            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="card"
              onClick={() => setShowTopSellingModal(true)}
              style={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                cursor: "pointer",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
              }}
            >
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-2 fw-semibold d-flex align-items-center gap-2">
                      <TrendingUp size={24} />
                      Top Selling Medicines
                    </h5>
                    <p className="mb-0" style={{ opacity: 0.9 }}>
                      View best performing products
                    </p>
                  </div>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      padding: "1rem",
                    }}
                  >
                    <TrendingUp size={32} />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="col-md-6">
            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="card"
              onClick={() => setShowLowStockModal(true)}
              style={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                cursor: "pointer",
                background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                color: "white",
              }}
            >
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-2 fw-semibold d-flex align-items-center gap-2">
                      <AlertTriangle size={24} />
                      Low Stock Alert
                    </h5>
                    <p className="mb-0" style={{ opacity: 0.9 }}>
                      Check medicines running low
                    </p>
                  </div>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      padding: "1rem",
                    }}
                  >
                    <AlertTriangle size={32} />
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Stats Cards */}
        <MedicineStatsCards
          medicines={medicines}
          report={report}
          topSelling={topSelling}
          loading={loading}
        />

        {/* Main Table Card */}
        <div className="row mt-4">
          <div className="col-12">
            <div
              className="card"
              style={{
                borderRadius: "16px",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              <div
                className="card-header"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                  borderRadius: "16px 16px 0 0",
                  padding: "1.5rem 2rem",
                  border: "none",
                }}
              >
                <h5 className="mb-0 fw-bold d-flex align-items-center">
                  <Pill size={24} className="me-2" />
                  All Medicines Inventory
                </h5>
              </div>
              <div className="card-body p-4">
                <MedicineListTable
                  medicines={medicines}
                  loading={loading}
                  onEdit={handleOpenEdit}
                  onStock={handleOpenStock}
                  // onSell={handleOpenSell} // ✅ REMOVE this prop
                  refresh={refresh}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AddMedicineModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        refresh={refresh}
      />

      <EditMedicineModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        medicine={selectedMedicine}
        refresh={refresh}
      />

      <AddStockModal
        show={showStockModal}
        onHide={() => setShowStockModal(false)}
        medicine={selectedMedicine}
        refresh={refresh} // ✅ Pass refresh prop
      />

      {/* ✅ REMOVE SellMedicineModal completely */}
      {/* <SellMedicineModal
        show={showSellModal}
        onHide={() => setShowSellModal(false)}
        medicine={selectedMedicine}
        refresh={refresh}
      /> */}

      {/* Top Selling Chart Modal */}
      {showTopSellingModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ background: "rgba(0,0,0,0.5)" }}
            onClick={() => setShowTopSellingModal(false)}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="modal fade show d-block"
            style={{ zIndex: 1055 }}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="modal-content"
                style={{
                  borderRadius: "16px",
                  border: "none",
                  overflow: "hidden",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "white",
                    border: "none",
                    padding: "1.5rem 2rem",
                  }}
                >
                  <h5 className="modal-title fw-bold d-flex align-items-center">
                    <TrendingUp size={24} className="me-2" />
                    Top Selling Medicines
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowTopSellingModal(false)}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="modal-body p-4">
                  <TopSellingChart data={topSelling} />
                </div>
                <div
                  className="modal-footer"
                  style={{ border: "none", padding: "1rem 2rem 1.5rem" }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowTopSellingModal(false)}
                    style={{
                      borderRadius: "10px",
                      padding: "0.6rem 1.5rem",
                      fontWeight: "500",
                    }}
                  >
                    <X size={18} className="me-2" />
                    Close
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}

      {/* Low Stock Chart Modal */}
      {showLowStockModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{ background: "rgba(0,0,0,0.5)" }}
            onClick={() => setShowLowStockModal(false)}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="modal fade show d-block"
            style={{ zIndex: 1055 }}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className="modal-content"
                style={{
                  borderRadius: "16px",
                  border: "none",
                  overflow: "hidden",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    color: "white",
                    border: "none",
                    padding: "1.5rem 2rem",
                  }}
                >
                  <h5 className="modal-title fw-bold d-flex align-items-center">
                    <AlertTriangle size={24} className="me-2" />
                    Low Stock Medicines
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowLowStockModal(false)}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="modal-body p-4">
                  <LowStockChart data={medicines} loading={loading} />
                </div>
                <div
                  className="modal-footer"
                  style={{ border: "none", padding: "1rem 2rem 1.5rem" }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowLowStockModal(false)}
                    style={{
                      borderRadius: "10px",
                      padding: "0.6rem 1.5rem",
                      fontWeight: "500",
                    }}
                  >
                    <X size={18} className="me-2" />
                    Close
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </div>
  );
};

export default ManageMedicines;